export const MASTER_CATEGORIES = [
  { value: "electronics", label: "Electronics" },
  { value: "appliances", label: "Appliances" },
  { value: "furniture", label: "Furniture" },
  { value: "clothing", label: "Clothing" },
  { value: "tools", label: "Tools" },
  { value: "sports", label: "Sports" },
  { value: "musical_instruments", label: "Musical Instruments" },
  { value: "jewelry", label: "Jewelry" },
  { value: "art", label: "Art" },
  { value: "books", label: "Books" },
  { value: "office", label: "Office" },
  { value: "garden", label: "Garden" },
  { value: "vehicles", label: "Vehicles" },
  { value: "toys", label: "Toys" },
  { value: "health", label: "Health" },
  { value: "kitchen", label: "Kitchen" },
  { value: "travel", label: "Travel & Luggage" },
  { value: "other", label: "Other" },
] as const;

export type CategoryValue = (typeof MASTER_CATEGORIES)[number]["value"];

/**
 * Convert a raw category value to its English display label.
 *
 * For localised rendering, use the `categories` i18n namespace instead:
 *   const { t } = useTranslation("categories");
 *   t(value) // e.g. t("electronics") → "Electronics" / "电子产品"
 *
 * This function is kept for non-component contexts (PDF generation, etc.)
 * that cannot use React hooks.
 */
export function formatCategoryLabel(value: string): string {
  const found = MASTER_CATEGORIES.find((c) => c.value === value);
  if (found) return found.label;
  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
